import React from 'react';
import IntroPage from './components/intro/IntroPage';
import { Route, Routes } from 'react-router-dom';
import InsurancesList from './components/dashboard/InsurancesList';
import Login from './components/auth/Login';
import InsurancesDetailPage from './components/dashboard/InsuranceDetailPage';
import IntroHeader from './components/intro/IntroHeader';
import { C } from './components/intro/const';
import IntroFooter from './components/intro/IntroFooter';
import ProtectedRoute from './components/ProtectedRoute';
import InsuranceForm from './components/admin/InsuranceForm';
import AdminInsurancesList from './components/admin/AdminInsurancesList';
import Register from './components/auth/Register';
import AdminGroupsList from './components/admin/AdminGroupList';
import AdminGroupForm from './components/admin/AdminGroupForm';
import AdminUsersList from './components/admin/AdminUsersList';
import AdminUserForm from './components/admin/AdminUserForm';

const App: React.FC = () => {

  /* ── inline global styles ── */
  const globalCss = `
    @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;500;600;700;800;900&display=swap');
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    html { scroll-behavior: smooth; }
    body { font-family: 'Vazirmatn', sans-serif; direction: rtl; }
    a { text-decoration: none; }
    .hov-lift { transition: transform .25s, box-shadow .25s; }
    .hov-lift:hover { transform: translateY(-6px); box-shadow: 0 16px 40px rgba(0,86,179,.14) !important; }
    .hov-btn { transition: background .2s, transform .2s; }
    .hov-btn:hover { transform: translateY(-2px); }
    .hov-nav { transition: color .2s; }
    .hov-nav:hover { color: ${C.accent} !important; }
    @media (max-width: 768px) {
      .hide-mobile { display: none !important; }
      .show-mobile { display: flex !important; }
      .grid-2 { grid-template-columns: 1fr !important; }
      .grid-3 { grid-template-columns: 1fr !important; }
      .grid-4 { grid-template-columns: 1fr 1fr !important; }
      .hero-grid { grid-template-columns: 1fr !important; }
      .hero-visual { display: none !important; }
    }
  `;

  return (
    <div>
      <style>{globalCss}</style>
      <IntroHeader></IntroHeader>
      <Routes >
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route element={<ProtectedRoute roles={["Admin", "Member"]} />}>
          <Route path="/portal" element={<InsurancesList />} />
          <Route path="/portal/:id" element={<InsurancesDetailPage />} />
        </Route>
        <Route element={<ProtectedRoute roles={["Admin"]} />}>
          <Route path="/admin/insurances" element={<AdminInsurancesList />} />
          <Route path="/admin/insurances/new" element={<InsuranceForm />} />
          <Route path="/admin/insurances/:id/edit" element={<InsuranceForm />} />
          <Route path="/admin/insurances/:id" element={<InsurancesDetailPage />} />
          <Route path="/admin/groups" element={<AdminGroupsList />} />
          <Route path="/admin/groups/new" element={<AdminGroupForm />} />
          <Route path="/admin/groups/:id/edit" element={<AdminGroupForm />} />
          <Route path="/admin/users" element={<AdminUsersList />} />
          <Route path="/admin/users/new" element={<AdminUserForm />} />
          <Route path="/admin/users/:id/edit" element={<AdminUserForm />} />

        </Route>

        <Route path="/" element={<IntroPage />} />
      </Routes>

      <IntroFooter></IntroFooter>
    </div>
  );
};


export default App;